module.exports = __webpack_public_path__ + "static/use-insurance-22afbfe0292153e54eeb75e413f10099.jpg";